import Axios from "axios";
import CONFIG from "../model/TSConfig";
import SubscriptionPromoCode2 from "@tootsweet/model/entities/SubscriptionPromoCode2";

export async function fetchSubscriptionPromoCode2(
  subscriptionPromoCode2Id?: string,
  token?: string
): Promise<SubscriptionPromoCode2 | null> {
  if (!subscriptionPromoCode2Id || !token) {
    return null;
  }
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.saasBackendUrl}/subscription-promo-code`,
    params: { id: subscriptionPromoCode2Id },
    headers: { Authorization: `Bearer ${token}` }
  });

  return res.data;
}
